/**
 * Auth Reducer
 */

export const SET_AUTH = 'SET_AUTH';
export const GET_AUTH = 'GET_AUTH';
export const GET_GENDER_ENUM_SUCCESS = 'GET_GENDER_ENUM_SUCCESS';
